import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { FiEdit2, FiPlus, FiX, FiCheck } from 'react-icons/fi';
import { getConfigRules, saveConfigRule } from '../../utils/journalApi';

const emptyRule = () => ({ config_key:'', config_value:'', company_code:'', doc_type:'', description:'', updated_by:'' });

export default function JournalConfig() {
  const [rules, setRules]       = useState([]);
  const [loading, setLoading]   = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [form, setForm]         = useState(emptyRule());
  const [errors, setErrors]     = useState({});
  const [saving, setSaving]     = useState(false);

  const load = async () => {
    setLoading(true);
    try { const r = await getConfigRules(); setRules(r.data.items ?? r.data); } catch (_) {}
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const openModal = (rule = null) => {
    setForm(rule ? { ...emptyRule(), ...rule } : emptyRule());
    setErrors({});
    setModalOpen(true);
  };

  const handleSave = async () => {
    const errs = {};
    if (!form.config_key.trim()) errs.config_key = 'Required';
    if (!form.config_value.trim()) errs.config_value = 'Required';
    if (Object.keys(errs).length) { setErrors(errs); return; }

    setSaving(true);
    try {
      await saveConfigRule({
        config_key:   form.config_key,
        config_value: form.config_value,
        company_code: form.company_code || undefined,
        doc_type:     form.doc_type     || undefined,
        description:  form.description  || undefined,
      });
      toast.success('Rule saved.');
      setModalOpen(false);
      load();
    } catch (err) {
      if (err.response?.status === 422) {
        setErrors(err.response.data?.detail || {});
        toast.error('Please fix errors.');
      }
    }
    setSaving(false);
  };

  const f = (key, label, required=false, props={}) => (
    <div className="journal-field" key={key}>
      <label>{label}{required ? ' *' : ''}</label>
      <input value={form[key]} onChange={e => setForm(p => ({...p, [key]:e.target.value}))}
        className={errors[key] ? 'err' : ''} {...props} />
      {errors[key] && <span className="journal-field-err">{errors[key]}</span>}
    </div>
  );

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'flex-end', marginBottom:14 }}>
        <button className="journal-btn primary" onClick={() => openModal()}>
          <FiPlus size={14} /> New Rule
        </button>
      </div>

      <div className="journal-panel">
        <div className="journal-panel-head"><h3>Validation Rules</h3></div>

        {loading ? (
          <div className="journal-loading"><div className="journal-spinner" /><span>Loading…</span></div>
        ) : rules.length === 0 ? (
          <div className="journal-empty">No rules configured.</div>
        ) : (
          <div className="journal-table-wrap">
            <table className="journal-table">
              <thead>
                <tr>
                  <th>Config Key</th><th>Value</th><th>Company</th><th>Doc Type</th>
                  <th>Description</th><th>Updated By</th><th>Updated At</th><th></th>
                </tr>
              </thead>
              <tbody>
                {rules.map((r,i) => (
                  <tr key={i}>
                    <td><strong>{r.config_key}</strong></td>
                    <td><code style={{ fontSize:11, background:'rgba(91,95,199,0.08)', padding:'2px 7px', borderRadius:5 }}>{r.config_value}</code></td>
                    <td className="journal-muted">{r.company_code||'—'}</td>
                    <td className="journal-muted">{r.doc_type||'—'}</td>
                    <td className="journal-muted" style={{ fontSize:'0.8rem' }}>{r.description||'—'}</td>
                    <td className="journal-muted">{r.updated_by||'—'}</td>
                    <td style={{ fontSize:11 }}>{r.updated_at ? new Date(r.updated_at).toLocaleString() : '—'}</td>
                    <td>
                      <button style={{ background:'none', border:'none', cursor:'pointer', color:'var(--jp)' }}
                        onClick={() => openModal(r)} title="Edit">
                        <FiEdit2 size={14} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {modalOpen && (
        <div className="j-modal-overlay" onClick={() => setModalOpen(false)}>
          <div className="j-modal" onClick={e => e.stopPropagation()}>
            <h3>{form.config_key ? `Edit — ${form.config_key}` : 'New Rule'}</h3>
            <div className="journal-field-grid">
              {f('config_key',   'Config Key',   true, { placeholder:'e.g. MAX_AMOUNT' })}
              {f('config_value', 'Config Value', true, { placeholder:'e.g. 1000000' })}
              {f('company_code', 'Company Code', false, { maxLength:4, placeholder:'Optional' })}
              {f('doc_type',     'Doc Type',     false, { maxLength:2, placeholder:'Optional' })}
            </div>
            <div className="journal-field" style={{ marginTop:12 }}>
              <label>Description</label>
              <input value={form.description} onChange={e => setForm(p => ({...p, description:e.target.value}))}
                placeholder="Optional description" />
            </div>
            <div className="j-modal-footer">
              <button className="journal-btn ghost" onClick={() => setModalOpen(false)}>
                <FiX size={14} /> Cancel
              </button>
              <button className="journal-btn primary" onClick={handleSave} disabled={saving}>
                <FiCheck size={14} /> {saving ? 'Saving…' : 'Save Rule'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
